/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис домов
 */

/**
 * Сервис домов
 */
export class BuildingServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения Дома.
   * Для пользователей типов owner, employee: в результат попадают только дома, которые привязаны к компании пользователя или дома квартирограамм привязанных к компании пользователя.
   * Метод доступен для: admin, service, owner, employee, seller, external_seller, ltp_first, bti
   */
  GetBuilding = (req: GetBuildingRequestDto, init?: RequestInit): Promise<GetBuildingResponseDto> => {
    return fm.request<GetBuildingRequestDto, GetBuildingResponseDto>(`${this.host}/access_control/api/v1/building/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка домов.
   * Для пользователей типов owner, employee: в результат попадают только дома, которые привязаны к компании пользователя или дома квартирограамм привязанных к компании пользователя.
   * При запросе через ApiKey происходит дополнительная фильтрация домов на основе доступности домов для этого ApiKey (фильтрация происходит по доступным AccessPoint для этой группы).
   * Метод доступен для: admin, service, owner, employee, ltp_first, bti.
   * Метод доступен для: ApiKey
   */
  GetBuildingList = (req?: GetBuildingListRequestDto, init?: RequestInit): Promise<GetBuildingListResponseDto[]> => {
    return fm.list<GetBuildingListRequestDto, GetBuildingListResponseDto>(`${this.host}/access_control/api/v1/building/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества домов.
   * Для пользователей типов owner, employee: в результат попадают только дома, которые привязаны к компании пользователя или дома квартирограамм привязанных к компании пользователя.
   * Метод доступен для: admin, service, owner, employee, ltp_first, bti
   */
  GetBuildingCount = (req: GetBuildingCountRequestDto, init?: RequestInit): Promise<GetBuildingCountResponseDto> => {
    return fm.request<GetBuildingCountRequestDto, GetBuildingCountResponseDto>(`${this.host}/access_control/api/v1/building/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения статуса режима работы с подписками у помещений дома.
   * Возвращает агрегированный статус по всем помещениям дома.
   * Метод доступен для: admin, service, ltp_first, bti
   */
  GetBuildingOrponSubscriptionMode = (req: GetBuildingOrponSubscriptionModeRequestDto, init?: RequestInit): Promise<GetBuildingOrponSubscriptionModeResponseDto> => {
    return fm.request<GetBuildingOrponSubscriptionModeRequestDto, GetBuildingOrponSubscriptionModeResponseDto>(`${this.host}/access_control/api/v1/building/orpon/${encodeURIComponent(req.orpon)}/subscription_mode${fm.buildQuery(req, ["orpon"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод проверки существования дома по ОРПОН.
   * Возвращает true если найден дом с указанным ОРПОН.
   * Метод доступен для: admin, service
   */
  GetBuildingOrponExists = (req: GetBuildingOrponExistsRequestDto, init?: RequestInit): Promise<GetBuildingOrponExistsResponseDto> => {
    return fm.request<GetBuildingOrponExistsRequestDto, GetBuildingOrponExistsResponseDto>(`${this.host}/access_control/api/v1/building/orpon/${encodeURIComponent(req.orpon)}/exists${fm.buildQuery(req, ["orpon"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 */
export enum BuildingPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type BuildingPagingDirectionTypeResponseEnum = keyof typeof BuildingPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type BuildingPagingDirectionTypeRequestEnum = Exclude<BuildingPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum BuildingPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По времени создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По улице, номеру дома, корпусу
   */
  STREET_THEN_NUMBER_THEN_PART = "STREET_THEN_NUMBER_THEN_PART",
}
/**
 * Справочник типов значений сортировки.
 */
export type BuildingPagingOrderByTypeResponseEnum = keyof typeof BuildingPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type BuildingPagingOrderByTypeRequestEnum = Exclude<BuildingPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник режимов работы с подписками
 */
export enum BuildingSubscriptionModeSubscriptionModeType {
  /**
   * Значение не указано
   */
  SUBSCRIPTION_MODE_TYPE_UNKNOWN = "SUBSCRIPTION_MODE_TYPE_UNKNOWN",
  /**
   * Режим работы с подписками включен на всех помещениях дома
   */
  ENABLED = "ENABLED",
  /**
   * Режим работы с подписками включен на некоторых помещениях дома
   */
  PARTIALLY_ENABLED = "PARTIALLY_ENABLED",
  /**
   * Режим работы с подписками выключен на всех помещениях дома
   */
  DISABLED = "DISABLED",
}
/**
 * Справочник режимов работы с подписками
 */
export type BuildingSubscriptionModeSubscriptionModeTypeResponseEnum = keyof typeof BuildingSubscriptionModeSubscriptionModeType
/**
 * Справочник режимов работы с подписками
 */
export type BuildingSubscriptionModeSubscriptionModeTypeRequestEnum = Exclude<BuildingSubscriptionModeSubscriptionModeTypeResponseEnum, "SUBSCRIPTION_MODE_TYPE_UNKNOWN">;

/**
 * Дом
 */
export type BuildingRequestDto = {
  /**
   * Идентификатор дома
   */
  id?: number
  /**
   * Идентификатор РФ
   */
  rfId: number
  /**
   * Идентификатор МРФ
   */
  mrfId: number
  /**
   * ОРПОН
   */
  orpon: string
  /**
   * Город
   */
  city: string
  /**
   * Улица
   */
  street: string
  /**
   * Номер дома
   */
  number?: string
  /**
   * Корпус
   */
  part?: string
  /**
   * Идентификатор компании
   */
  companyId: number
  /**
   * Префикс
   */
  prefix?: string
  /**
   * Идентификатор квартирограммы
   */
  flatgrammId: number
  /**
   * ОРПОН города, в котором находится дом
   */
  cityOrpon?: string
  /**
   * Идентификатор в федеральной информационной адресной системе.
   * Тип: Guid
   */
  fias?: string | null
  /**
   * Наименование района города.
   * # Диапазон: 0..200
   */
  district?: string | null
  /**
   * Уникальный номер адреса.
   * # Диапазон: 0..9999999999
   */
  unom?: string | null
  /**
   * ОРПОН региона
   */
  regionOrpon?: string
  /**
   * Смещение таймзоны в минутах.
   * # Диапазон: -720..840
   */
  utcOffset?: number
  /**
   * Флаг указывает на то могут ли жители этого дома приобрести ключи домофона в партнёрских салонах или на маркетплейсах
   */
  isKeyPurchasePossibleInSalePoints?: boolean
  /**
   * Флаг указывает на то могут ли жители этого дома приобретать ключи через управляющую компанию
   */
  isKeyPurchasePossibleInManagementCompany?: boolean
  /**
   * Флаг указывает на то могут ли жители этого дома приобрести ключи напрямую у домофонной компании
   */
  isKeyPurchasePossibleInIntercomCompany?: boolean
  /**
   * Флаг указывает на то поддерживает ли дом использование RFID-меток с типом MIFARE
   */
  isRfidMifareSupported?: boolean
  /**
   * Наименование муниципального района.
   * # Диапазон: 0..64
   */
  area?: string | null
  /**
   * ОРПОН муниципального района.
   * # Диапазон: 0..9999999999
   */
  areaOrpon?: string | null
  /**
   * КЛАДР муниципального района.
   * # Диапазон: 0..32
   */
  areaKladr?: string | null
  /**
   * Признак принадлежности населённого пункта к столичному статусу.
   * 1 — центр района.
   * 2 — центр региона.
   * 3 — центр района и региона.
   * 4 — центральный район региона.
   * 0 — ничего из перечисленного.
   * # Диапазон: 0..4
   */
  capitalMarker?: number | null
  /**
   * КЛАДР-код города.
   * # Диапазон: 0..17
   */
  cityKladr?: string | null
  /**
   * КЛАДР-код строения.
   * # Диапазон: 0..17
   */
  kladr?: string | null
  /**
   * Уровень детализации, до которого адрес найден в ФИАС.
   * 0 — страна.
   * 1 — регион.
   * 3 — район.
   * 4 — город.
   * 5 — район города.
   * 6 — населенный пункт.
   * 7 — улица.
   * 8 — дом.
   * 9 — квартира.
   * 65 — планировочная структура.
   * 90 — доп. территория.
   * 91 — улица в доп. территории.
   * -1 — иностранный или пустой.
   * # Диапазон: -1..99
   */
  fiasLevel?: number | null
  /**
   * Уровень детализации, до которого адрес найден в ФИАС.
   * 0 — актуальный.
   * 1-50 — переименован.
   * 51 — переподчинен.
   * 99 — удален.
   * # Диапазон: 0..99
   */
  fiasActualityState?: number | null
  /**
   * Координаты: широта
   */
  geoLat?: number | null
  /**
   * Координаты: долгота
   */
  geoLon?: number | null
  /**
   * Код ОКАТО
   */
  okato?: string | null
  /**
   * Код ОКТМО
   */
  oktmo?: string | null
  /**
   * Почтовый индекс
   */
  postalCode?: number | null
  /**
   * Наименование региона.
   * # Диапазон: 0..64
   */
  region?: string | null
  /**
   * КЛАДР-код региона.
   * # Диапазон: 0..32
   */
  regionKladr?: string | null
  /**
   * КЛАДР-код улицы.
   * # Диапазон: 0..32
   */
  streetKladr?: string | null
  /**
   * ОРПОН улицы.
   * # Диапазон: 0..9999999999
   */
  streetOrpon?: string | null
  /**
   * КЛАДР-код дома.
   * # Диапазон: 0..32
   */
  houseKladr?: string | null
}
/**
 * Дом
 */
export type BuildingResponseDto = {
  /**
   * Идентификатор дома
   */
  id: number
  /**
   * Идентификатор РФ
   */
  rfId: number
  /**
   * Идентификатор МРФ
   */
  mrfId: number
  /**
   * ОРПОН
   */
  orpon: string
  /**
   * Город
   */
  city: string
  /**
   * Улица
   */
  street: string
  /**
   * Номер дома
   */
  number: string
  /**
   * Корпус
   */
  part: string
  /**
   * Идентификатор компании
   */
  companyId: number
  /**
   * Префикс
   */
  prefix: string
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата удаления.
   * # Тип: DateTime
   */
  readonly deletedAt: string | null
  /**
   * Идентификатор квартирограммы
   */
  flatgrammId: number
  /**
   * ОРПОН города, в котором находится дом
   */
  cityOrpon: string
  /**
   * Идентификатор в федеральной информационной адресной системе.
   * Тип: Guid
   */
  fias: string | null
  /**
   * Наименование района города.
   * # Диапазон: 0..200
   */
  district: string | null
  /**
   * Уникальный номер адреса.
   * # Диапазон: 0..9999999999
   */
  unom: string | null
  /**
   * ОРПОН региона
   */
  regionOrpon: string
  /**
   * Смещение таймзоны в минутах.
   * # Диапазон: -720..840
   */
  utcOffset: number
  /**
   * Флаг указывает на то могут ли жители этого дома приобрести ключи домофона в партнёрских салонах или на маркетплейсах
   */
  isKeyPurchasePossibleInSalePoints: boolean
  /**
   * Флаг указывает на то могут ли жители этого дома приобретать ключи через управляющую компанию
   */
  isKeyPurchasePossibleInManagementCompany: boolean
  /**
   * Флаг указывает на то могут ли жители этого дома приобрести ключи напрямую у домофонной компании
   */
  isKeyPurchasePossibleInIntercomCompany: boolean
  /**
   * Флаг указывает на то поддерживает ли дом использование RFID-меток с типом MIFARE
   */
  isRfidMifareSupported: boolean
  /**
   * Наименование муниципального района.
   * # Диапазон: 0..64
   */
  area: string | null
  /**
   * ОРПОН муниципального района.
   * # Диапазон: 0..9999999999
   */
  areaOrpon: string | null
  /**
   * КЛАДР муниципального района.
   * # Диапазон: 0..32
   */
  areaKladr: string | null
  /**
   * Признак принадлежности населённого пункта к столичному статусу.
   * 1 — центр района.
   * 2 — центр региона.
   * 3 — центр района и региона.
   * 4 — центральный район региона.
   * 0 — ничего из перечисленного.
   * # Диапазон: 0..4
   */
  capitalMarker: number | null
  /**
   * КЛАДР-код города.
   * # Диапазон: 0..17
   */
  cityKladr: string | null
  /**
   * КЛАДР-код строения.
   * # Диапазон: 0..17
   */
  kladr: string | null
  /**
   * Уровень детализации, до которого адрес найден в ФИАС.
   * 0 — страна.
   * 1 — регион.
   * 3 — район.
   * 4 — город.
   * 5 — район города.
   * 6 — населенный пункт.
   * 7 — улица.
   * 8 — дом.
   * 9 — квартира.
   * 65 — планировочная структура.
   * 90 — доп. территория.
   * 91 — улица в доп. территории.
   * -1 — иностранный или пустой.
   * # Диапазон: -1..99
   */
  fiasLevel: number | null
  /**
   * Уровень детализации, до которого адрес найден в ФИАС.
   * 0 — актуальный.
   * 1-50 — переименован.
   * 51 — переподчинен.
   * 99 — удален.
   * # Диапазон: 0..99
   */
  fiasActualityState: number | null
  /**
   * Координаты: широта
   */
  geoLat: number | null
  /**
   * Координаты: долгота
   */
  geoLon: number | null
  /**
   * Код ОКАТО
   */
  okato: string | null
  /**
   * Код ОКТМО
   */
  oktmo: string | null
  /**
   * Почтовый индекс
   */
  postalCode: number | null
  /**
   * Наименование региона.
   * # Диапазон: 0..64
   */
  region: string | null
  /**
   * КЛАДР-код региона.
   * # Диапазон: 0..32
   */
  regionKladr: string | null
  /**
   * КЛАДР-код улицы.
   * # Диапазон: 0..32
   */
  streetKladr: string | null
  /**
   * ОРПОН улицы.
   * # Диапазон: 0..9999999999
   */
  streetOrpon: string | null
  /**
   * КЛАДР-код дома.
   * # Диапазон: 0..32
   */
  houseKladr: string | null
}
/**
 * Фильтр по домам
 */
export type BuildingFilterRequestDto = {
  /**
   * По идентификаторам МРФ
   */
  mrfIds?: number[]
  /**
   * По идентификаторам РФ
   */
  rfIds?: number[]
  /**
   * По идентификаторам устройств
   */
  deviceIds?: number[]
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds?: number[]
  /**
   * По орпонам
   */
  orpons?: string[]
}
/**
 * Фильтр по домам
 */
export type BuildingFilterResponseDto = {
  /**
   * По идентификаторам МРФ
   */
  mrfIds: number[]
  /**
   * По идентификаторам РФ
   */
  rfIds: number[]
  /**
   * По идентификаторам устройств
   */
  deviceIds: number[]
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds: number[]
  /**
   * По орпонам
   */
  orpons: string[]
}
/**
 * Постраничный вывод
 */
export type BuildingPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType?: BuildingPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: BuildingPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type BuildingPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType: BuildingPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: BuildingPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Агрегированный статус режима работы с подписками на доме
 */
export type BuildingSubscriptionModeRequestDto = {
  /**
   * Режим работы с подписками на доме
   */
  subscriptionModeType?: BuildingSubscriptionModeSubscriptionModeTypeRequestEnum | "SUBSCRIPTION_MODE_TYPE_UNKNOWN"
}
/**
 * Агрегированный статус режима работы с подписками на доме
 */
export type BuildingSubscriptionModeResponseDto = {
  /**
   * Режим работы с подписками на доме
   */
  subscriptionModeType: BuildingSubscriptionModeSubscriptionModeTypeResponseEnum
}
/**
 * Запрос получения количества домов
 */
export type GetBuildingCountRequestDto = {
  /**
   * Фильтр
   */
  filter: BuildingFilterRequestDto
}
/**
 * Ответ на запрос получения количества домов
 */
export type GetBuildingCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество
   */
  readonly data: number
}>
/**
 * Запрос получения списка домов
 */
export type GetBuildingListRequestDto = {
  /**
   * Фильтр
   */
  filter?: BuildingFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: BuildingPagingRequestDto
}>
/**
 * Ответ на запрос получения списка домов
 */
export type GetBuildingListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Квартира
   */
  readonly data: BuildingResponseDto
  /**
   * Ошибка
   */
  readonly error: GetBuildingListResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetBuildingListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetBuildingListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос проверки существования дома по ОРПОН
 */
export type GetBuildingOrponExistsRequestDto = {
  /**
   * ОРПОН дома.
   * # Диапазон: 1..9223372036854775807
   */
  orpon: string
}
/**
 * Ответ на запрос проверки существования дома по ОРПОН
 */
export type GetBuildingOrponExistsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Результат проверки: true - если дом существует, false - в противном случае
   */
  readonly data: boolean
  /**
   * Ошибка
   */
  readonly error: GetBuildingOrponExistsResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetBuildingOrponExistsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetBuildingOrponExistsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения агрегированного статуса режима работы с подписками дома
 */
export type GetBuildingOrponSubscriptionModeRequestDto = {
  /**
   * ОРПОН.
   * # Диапазон: 1..9223372036854775807
   */
  orpon: string
}
/**
 * Ответ на запрос получения агрегированного статуса режима работы с подписками дома
 */
export type GetBuildingOrponSubscriptionModeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Агрегированный статус режима работы с подписками дома
   */
  readonly data: BuildingSubscriptionModeResponseDto
  /**
   * Ошибка
   */
  readonly error: GetBuildingOrponSubscriptionModeResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetBuildingOrponSubscriptionModeResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetBuildingOrponSubscriptionModeResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения дома
 */
export type GetBuildingRequestDto = {
  /**
   * Идентификатор дома
   */
  id: number
}
/**
 * Ответ на запрос получения дома
 */
export type GetBuildingResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Квартира
   */
  readonly data: BuildingResponseDto
  /**
   * Ошибка
   */
  readonly error: GetBuildingResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetBuildingResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetBuildingResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Дом
   */
  "Building": {
    "kind": "class",
    "text": "Дом",
    "fields": {
      /**
       * Идентификатор дома
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор дома",
      },
      /**
       * Идентификатор РФ
       */
      "rfId": {
        "type": "int32",
        "text": "Идентификатор РФ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор МРФ
       */
      "mrfId": {
        "type": "int32",
        "text": "Идентификатор МРФ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОН
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Город
       */
      "city": {
        "type": "string",
        "text": "Город",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Улица
       */
      "street": {
        "type": "string",
        "text": "Улица",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер дома
       */
      "number": {
        "type": "string",
        "text": "Номер дома",
      },
      /**
       * Корпус
       */
      "part": {
        "type": "string",
        "text": "Корпус",
      },
      /**
       * Идентификатор компании
       */
      "companyId": {
        "type": "int32",
        "text": "Идентификатор компании",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Префикс
       */
      "prefix": {
        "type": "string",
        "text": "Префикс",
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата удаления.
       * # Тип: DateTime
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления.\n# Тип: DateTime",
      },
      /**
       * Идентификатор квартирограммы
       */
      "flatgrammId": {
        "type": "int32",
        "text": "Идентификатор квартирограммы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОН города, в котором находится дом
       */
      "cityOrpon": {
        "type": "int64",
        "text": "ОРПОН города, в котором находится дом",
      },
      /**
       * Идентификатор в федеральной информационной адресной системе.
       * Тип: Guid
       */
      "fias": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор в федеральной информационной адресной системе.\nТип: Guid",
      },
      /**
       * Наименование района города.
       * # Диапазон: 0..200
       */
      "district": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование района города.\n# Диапазон: 0..200",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 200,
            "message": "Значение не входит в допустимый диапазон. Максимум: 200"
          },
        }
      },
      /**
       * Уникальный номер адреса.
       * # Диапазон: 0..9999999999
       */
      "unom": {
        "type": "google.protobuf.Int64Value",
        "text": "Уникальный номер адреса.\n# Диапазон: 0..9999999999",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 9999999999,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9999999999"
          },
        }
      },
      /**
       * ОРПОН региона
       */
      "regionOrpon": {
        "type": "int64",
        "text": "ОРПОН региона",
      },
      /**
       * Смещение таймзоны в минутах.
       * # Диапазон: -720..840
       */
      "utcOffset": {
        "type": "int32",
        "text": "Смещение таймзоны в минутах.\n# Диапазон: -720..840",
        "rules": {
          "min": {
            "value": -720,
            "message": "Значение не входит в допустимый диапазон. Минимум: -720"
          },
          "max": {
            "value": 840,
            "message": "Значение не входит в допустимый диапазон. Максимум: 840"
          },
        }
      },
      /**
       * Флаг указывает на то могут ли жители этого дома приобрести ключи домофона в партнёрских салонах или на маркетплейсах
       */
      "isKeyPurchasePossibleInSalePoints": {
        "type": "bool",
        "text": "Флаг указывает на то могут ли жители этого дома приобрести ключи домофона в партнёрских салонах или на маркетплейсах",
      },
      /**
       * Флаг указывает на то могут ли жители этого дома приобретать ключи через управляющую компанию
       */
      "isKeyPurchasePossibleInManagementCompany": {
        "type": "bool",
        "text": "Флаг указывает на то могут ли жители этого дома приобретать ключи через управляющую компанию",
      },
      /**
       * Флаг указывает на то могут ли жители этого дома приобрести ключи напрямую у домофонной компании
       */
      "isKeyPurchasePossibleInIntercomCompany": {
        "type": "bool",
        "text": "Флаг указывает на то могут ли жители этого дома приобрести ключи напрямую у домофонной компании",
      },
      /**
       * Флаг указывает на то поддерживает ли дом использование RFID-меток с типом MIFARE
       */
      "isRfidMifareSupported": {
        "type": "bool",
        "text": "Флаг указывает на то поддерживает ли дом использование RFID-меток с типом MIFARE",
      },
      /**
       * Наименование муниципального района.
       * # Диапазон: 0..64
       */
      "area": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование муниципального района.\n# Диапазон: 0..64",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * ОРПОН муниципального района.
       * # Диапазон: 0..9999999999
       */
      "areaOrpon": {
        "type": "google.protobuf.Int64Value",
        "text": "ОРПОН муниципального района.\n# Диапазон: 0..9999999999",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 9999999999,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9999999999"
          },
        }
      },
      /**
       * КЛАДР муниципального района.
       * # Диапазон: 0..32
       */
      "areaKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР муниципального района.\n# Диапазон: 0..32",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * Признак принадлежности населённого пункта к столичному статусу.
       * 1 — центр района.
       * 2 — центр региона.
       * 3 — центр района и региона.
       * 4 — центральный район региона.
       * 0 — ничего из перечисленного.
       * # Диапазон: 0..4
       */
      "capitalMarker": {
        "type": "google.protobuf.Int32Value",
        "text": "Признак принадлежности населённого пункта к столичному статусу.\n1 — центр района.\n2 — центр региона.\n3 — центр района и региона.\n4 — центральный район региона.\n0 — ничего из перечисленного.\n# Диапазон: 0..4",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4"
          },
        }
      },
      /**
       * КЛАДР-код города.
       * # Диапазон: 0..17
       */
      "cityKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код города.\n# Диапазон: 0..17",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Максимум: 17"
          },
        }
      },
      /**
       * КЛАДР-код строения.
       * # Диапазон: 0..17
       */
      "kladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код строения.\n# Диапазон: 0..17",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Максимум: 17"
          },
        }
      },
      /**
       * Уровень детализации, до которого адрес найден в ФИАС.
       * 0 — страна.
       * 1 — регион.
       * 3 — район.
       * 4 — город.
       * 5 — район города.
       * 6 — населенный пункт.
       * 7 — улица.
       * 8 — дом.
       * 9 — квартира.
       * 65 — планировочная структура.
       * 90 — доп. территория.
       * 91 — улица в доп. территории.
       * -1 — иностранный или пустой.
       * # Диапазон: -1..99
       */
      "fiasLevel": {
        "type": "google.protobuf.Int32Value",
        "text": "Уровень детализации, до которого адрес найден в ФИАС.\n0 — страна.\n1 — регион.\n3 — район.\n4 — город.\n5 — район города.\n6 — населенный пункт.\n7 — улица.\n8 — дом.\n9 — квартира.\n65 — планировочная структура.\n90 — доп. территория.\n91 — улица в доп. территории.\n-1 — иностранный или пустой.\n# Диапазон: -1..99",
        "rules": {
          "min": {
            "value": -1,
            "message": "Значение не входит в допустимый диапазон. Минимум: -1"
          },
          "max": {
            "value": 99,
            "message": "Значение не входит в допустимый диапазон. Максимум: 99"
          },
        }
      },
      /**
       * Уровень детализации, до которого адрес найден в ФИАС.
       * 0 — актуальный.
       * 1-50 — переименован.
       * 51 — переподчинен.
       * 99 — удален.
       * # Диапазон: 0..99
       */
      "fiasActualityState": {
        "type": "google.protobuf.Int32Value",
        "text": "Уровень детализации, до которого адрес найден в ФИАС.\n0 — актуальный.\n1-50 — переименован.\n51 — переподчинен.\n99 — удален.\n# Диапазон: 0..99",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 99,
            "message": "Значение не входит в допустимый диапазон. Максимум: 99"
          },
        }
      },
      /**
       * Координаты: широта
       */
      "geoLat": {
        "type": "google.protobuf.DoubleValue",
        "text": "Координаты: широта",
      },
      /**
       * Координаты: долгота
       */
      "geoLon": {
        "type": "google.protobuf.DoubleValue",
        "text": "Координаты: долгота",
      },
      /**
       * Код ОКАТО
       */
      "okato": {
        "type": "google.protobuf.Int64Value",
        "text": "Код ОКАТО",
      },
      /**
       * Код ОКТМО
       */
      "oktmo": {
        "type": "google.protobuf.Int64Value",
        "text": "Код ОКТМО",
      },
      /**
       * Почтовый индекс
       */
      "postalCode": {
        "type": "google.protobuf.Int32Value",
        "text": "Почтовый индекс",
      },
      /**
       * Наименование региона.
       * # Диапазон: 0..64
       */
      "region": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование региона.\n# Диапазон: 0..64",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * КЛАДР-код региона.
       * # Диапазон: 0..32
       */
      "regionKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код региона.\n# Диапазон: 0..32",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * КЛАДР-код улицы.
       * # Диапазон: 0..32
       */
      "streetKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код улицы.\n# Диапазон: 0..32",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * ОРПОН улицы.
       * # Диапазон: 0..9999999999
       */
      "streetOrpon": {
        "type": "google.protobuf.Int64Value",
        "text": "ОРПОН улицы.\n# Диапазон: 0..9999999999",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 9999999999,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9999999999"
          },
        }
      },
      /**
       * КЛАДР-код дома.
       * # Диапазон: 0..32
       */
      "houseKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код дома.\n# Диапазон: 0..32",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
    },
  },
  /**
   * Фильтр по домам
   */
  "BuildingFilter": {
    "kind": "class",
    "text": "Фильтр по домам",
    "fields": {
      /**
       * По идентификаторам МРФ
       */
      "mrfIds": {
        "type": "int32",
        "text": "По идентификаторам МРФ",
      },
      /**
       * По идентификаторам РФ
       */
      "rfIds": {
        "type": "int32",
        "text": "По идентификаторам РФ",
      },
      /**
       * По идентификаторам устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "По идентификаторам устройств",
      },
      /**
       * По идентификаторам квартирограмм
       */
      "flatgrammIds": {
        "type": "int32",
        "text": "По идентификаторам квартирограмм",
      },
      /**
       * По орпонам
       */
      "orpons": {
        "type": "int64",
        "text": "По орпонам",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "BuildingPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CREATED_AT
       */
      "orderByType": {
        "type": "BuildingPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CREATED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "BuildingPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Агрегированный статус режима работы с подписками на доме
   */
  "BuildingSubscriptionMode": {
    "kind": "class",
    "text": "Агрегированный статус режима работы с подписками на доме",
    "fields": {
      /**
       * Режим работы с подписками на доме
       */
      "subscriptionModeType": {
        "type": "BuildingSubscriptionMode.SubscriptionModeType",
        "text": "Режим работы с подписками на доме",
      },
    },
  },
  /**
   * Запрос получения количества домов
   */
  "GetBuildingCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества домов",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "BuildingFilter",
        "text": "Фильтр",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения количества домов
   */
  "GetBuildingCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества домов",
    "fields": {
      /**
       * Количество
       */
      "data": {
        "type": "int32",
        "text": "Количество",
      },
    },
  },
  /**
   * Запрос получения списка домов
   */
  "GetBuildingListRequest": {
    "kind": "class",
    "text": "Запрос получения списка домов",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "BuildingFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "BuildingPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка домов
   */
  "GetBuildingListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка домов",
    "fields": {
      /**
       * Квартира
       */
      "data": {
        "type": "Building",
        "text": "Квартира",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetBuildingListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetBuildingListResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос проверки существования дома по ОРПОН
   */
  "GetBuildingOrponExistsRequest": {
    "kind": "class",
    "text": "Запрос проверки существования дома по ОРПОН",
    "fields": {
      /**
       * ОРПОН дома.
       * # Диапазон: 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН дома.\n# Диапазон: 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 9223372036854775807,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9223372036854775807"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос проверки существования дома по ОРПОН
   */
  "GetBuildingOrponExistsResponse": {
    "kind": "class",
    "text": "Ответ на запрос проверки существования дома по ОРПОН",
    "fields": {
      /**
       * Результат проверки: true - если дом существует, false - в противном случае
       */
      "data": {
        "type": "bool",
        "text": "Результат проверки: true - если дом существует, false - в противном случае",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetBuildingOrponExistsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetBuildingOrponExistsResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения агрегированного статуса режима работы с подписками дома
   */
  "GetBuildingOrponSubscriptionModeRequest": {
    "kind": "class",
    "text": "Запрос получения агрегированного статуса режима работы с подписками дома",
    "fields": {
      /**
       * ОРПОН.
       * # Диапазон: 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН.\n# Диапазон: 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 9223372036854775807,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9223372036854775807"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос получения агрегированного статуса режима работы с подписками дома
   */
  "GetBuildingOrponSubscriptionModeResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения агрегированного статуса режима работы с подписками дома",
    "fields": {
      /**
       * Агрегированный статус режима работы с подписками дома
       */
      "data": {
        "type": "BuildingSubscriptionMode",
        "text": "Агрегированный статус режима работы с подписками дома",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetBuildingOrponSubscriptionModeResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetBuildingOrponSubscriptionModeResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения дома
   */
  "GetBuildingRequest": {
    "kind": "class",
    "text": "Запрос получения дома",
    "fields": {
      /**
       * Идентификатор дома
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения дома
   */
  "GetBuildingResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения дома",
    "fields": {
      /**
       * Квартира
       */
      "data": {
        "type": "Building",
        "text": "Квартира",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetBuildingResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetBuildingResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "BuildingPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "BuildingPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По времени создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "По времени создания",
      },
      /**
       * По улице, номеру дома, корпусу
       */
      "STREET_THEN_NUMBER_THEN_PART": {
        "i": 3,
        "text": "По улице, номеру дома, корпусу",
      },
    },
  },
  /**
   * Справочник режимов работы с подписками
   */
  "BuildingSubscriptionMode.SubscriptionModeType": {
    "kind": "enum",
    "text": "Справочник режимов работы с подписками",
    "values": {
      /**
       * Значение не указано
       */
      "SUBSCRIPTION_MODE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Режим работы с подписками включен на всех помещениях дома
       */
      "ENABLED": {
        "i": 1,
        "text": "Режим работы с подписками включен на всех помещениях дома",
      },
      /**
       * Режим работы с подписками включен на некоторых помещениях дома
       */
      "PARTIALLY_ENABLED": {
        "i": 2,
        "text": "Режим работы с подписками включен на некоторых помещениях дома",
      },
      /**
       * Режим работы с подписками выключен на всех помещениях дома
       */
      "DISABLED": {
        "i": 3,
        "text": "Режим работы с подписками выключен на всех помещениях дома",
      },
    },
  },
}